import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const BarGraph20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path d='M16.75 2V15H18.25V2H16.75Z' fill='currentColor' />
    <path d='M1.75 15V10.5H3.25V15H1.75Z' fill='currentColor' />
    <path d='M0 17.25H20V18.75H0V17.25Z' fill='currentColor' />
    <path d='M8.25 5V15H6.75V5H8.25Z' fill='currentColor' />
    <path d='M13.25 15V8H11.75V15H13.25Z' fill='currentColor' />
  </Svg>
);

BarGraph20.displayName = 'BarGraph20';
export default BarGraph20;
